import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { Buffer } from "buffer"

import { VerifyCertificate } from "../../routes/cryptography";

//const feedback = "Ты сделал это!";

class VerifyCert extends Component {
  constructor() {
    super();
    this.state = {
      dataCert: {
        crl: "",
        p7b: "",
        statusCert: ""
      },
      fileCert: "",

      certFileName: "файл",
      sosFileName: "файл",
      p7bFileName: "файл",

      certFileIsOpen: false,
      sosFileIsOpen: false,
      p7bFileIsOpen: false,

      isValidCertFileSize: true,
      isValidSOSKeyFileSize: true,
      isValidP7bKeyFileSize: true,

      errors: {}
    };

    this.handleFileSOSChange = this.handleFileSOSChange.bind(this);
    this.handleVerCertSubmit = this.handleVerCertSubmit.bind(this);
    this.handleFileP7BChange = this.handleFileP7BChange.bind(this);
    this.handleCertChange = this.handleCertChange.bind(this);

  }


  handleFileSOSChange() {
    try {
      const file = document.getElementById("fileSOS").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {
        this.setState({ sosFileName: file.name, isValidSOSKeyFileSize: true, sosFileIsOpen: true });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer));

          this.setState({
            dataCert: { ...this.state.dataCert, crl: data }
          });
          //console.log(data);
        };
        reader.onerror = e => {
          console.error(e);
        };
      } else {
        this.setState({ sosFileName: "файл", isValidSOSKeyFileSize: false, sosFileIsOpen: false });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handleFileP7BChange() {
    try {
      const file = document.getElementById("fileP7B").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {
        this.setState({ p7bFileName: file.name, isValidP7bKeyFileSize: true, p7bFileIsOpen: true });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer));

          this.setState({
            dataCert: { ...this.state.dataCert, p7b: data }
          });
          //console.log(data);
        };
        reader.onerror = e => {
          console.error(e);
        };
      } else {
        this.setState({ p7bFileName: "файл", isValidP7bKeyFileSize: false, p7bFileIsOpen: false });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handleVerCertSubmit(e) {
    e.preventDefault();
    try {
      //console.log(`crl: ${this.state.dataCert.crl}`);
      //console.log(`cert: ${this.state.fileCert}`);
      //console.log(`p7b: ${this.state.dataCert.p7b}`);

      VerifyCertificate(
        this.state.dataCert.p7b,
        this.state.fileCert,
        this.state.dataCert.crl
      ).then(result => {
        try {
          //console.log(result);
          if (result.status === 200) {
            this.setState({
              dataCert: { ...this.state.dataCert, statusCert: result.data }
            });
          } else {
            this.setState({
              dataCert: {
                ...this.state.dataCert,
                statusCert: "Неуспешная проверка сертификата!"
              }
            });
          }
        } catch (error) {
          //console.log(error);
        }
      });
    } catch (error) {
      //console.log(error);
    }
  }
  handleCertChange() {
    try {
      const file = document.getElementById("fileCert").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {
        this.setState({ certFileName: file.name, isValidCertFileSize: true, certFileIsOpen: true });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer));

          this.setState({
            fileCert: data
          });
          //console.log(data);
        };
        reader.onerror = e => {
          console.error(e);
        };
      } else {
        this.setState({ certFileName: "файл", isValidCertFileSize: false, certFileIsOpen: false });
      }
    } catch (error) {
      //console.log(error);
    }
  }


  render() {
    return (
      <div className="container">
        <h4 className="major">Проверка сертификата</h4>
        <Form onSubmit={this.handleVerCertSubmit}>
          <div className="sm-4">
            <Form.Group>
              <Form.Label>Выберите сертификат</Form.Label>
              <Form.File custom>
                <Form.File.Input
                  onChange={this.handleCertChange}
                  id="fileCert"
                  isValid={this.state.certFileIsOpen}
                  isInvalid={!this.state.isValidCertFileSize}
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.certFileName}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>
              </Form.File>
            </Form.Group>

            <Form.Group>
              <Form.Label>Выберите файл СОС</Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="fileSOS"
                  isValid={this.state.sosFileIsOpen}
                  onChange={this.handleFileSOSChange}
                  isInvalid={!this.state.isValidSOSKeyFileSize}
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.sosFileName}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>
              </Form.File>
            </Form.Group>
            <Form.Group>
              <Form.Label>Выберите файл цепочки доверия(P7B) </Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="fileP7B"
                  isValid={this.state.p7bFileIsOpen}
                  onChange={this.handleFileP7BChange}
                  isInvalid={!this.state.isValidP7bKeyFileSize}

                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.p7bFileName}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>
              </Form.File>
            </Form.Group>
            <Form.Label style={{ float: "left" }}>
              {this.state.dataCert.statusCert}
            </Form.Label>

            <Button
              style={{ float: "right" }}
              variant="success"
              type="submit"
              size="sm"
            >
              Проверить
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}
export default connect()(withRouter(VerifyCert));
